import * as actionTypes from "./actionTypes";
import * as actionsTypes from "../../baseApp/users/actionTypes";

const searchVisitors = searchFields => ({
    type: actionTypes.VISITOR_SEARCH_REQUEST,
    searchFields
});

const getVisitorData = visitorId => ({
    type: actionTypes.GET_VISITOR_REQUEST,
    visitorId
});

const editVisitor = (visitorId, visitorData) => ({
    type: actionTypes.EDIT_VISITOR_REQUEST,
    visitorId,
    visitorData
});

const resetVisitorForm = () => ({
    type: actionsTypes.RESET_USER_FORM
})

export default {
    searchVisitors,
    getVisitorData,
    editVisitor,
    resetVisitorForm,
}